module.exports = __webpack_public_path__ + "img/liucheng.64c39300.png";